/* React hooks */
import { useEffect } from "react";
/* Components */
import { useLocation } from "react-router-dom";
import { getCountryList } from "../../api/admin/addressReq";
import useAuth from "../../hooks/useAuth";
import useData from "../../hooks/useData";
import { validateFormInput } from "../../helper/tools";
import CityNameZipSuggest from "../../components/common/input-layout/CityNameZipSuggest";
import DateInput from "../../components/common/input-layout/DateInput";
import useDeceased from "../../hooks/useDeceased";


export default function FormBirthInfos({ fullForm, setFullForm, dateRequired = true }) {

    const { auth } = useAuth();
    const token = auth.token;
    const { countryList, setCountryList, selectedBirthplace } = useData();
    const { pathname } = useLocation();
    const { newForm, setNewForm } = useDeceased({});

    const onChange = (e) => {
        setFullForm(prevForm => {
            const newValues = { ...prevForm, [e.target.name]: e.target.value };
            
            if (pathname?.includes("nouveau")) {
                setNewForm({ ...newForm, ...newValues });
            }
            
            return newValues;
        });

        validateFormInput(e);
    };


    const onChangeBirthPlaceData = (e) => {

        const fieldMap = {
            'birthZipcode': 'zipcode',
            'birthCity': 'city',
            'birthCountry': 'country'
        };
        
        const fieldKey = fieldMap[e.target.name] || e.target.name;
        
        setFullForm(prevForm => {
            const newValues = { 
                ...prevForm, 
                birthplace: { 
                    ...prevForm?.birthplace, 
                    [fieldKey]: e.target.value 
                } 
            };
            
            if (pathname?.includes("nouveau")) {
                setNewForm(newValues);
            }
            
            return newValues;
        });

        validateFormInput(e);
    };

    const apiCountryList = async () => {
        const response = await getCountryList(token)
        setCountryList(response)
    }

    useEffect(() => {
        apiCountryList()
    }, [token]);

    useEffect(() => {
        if (!fullForm?.birthplace?.country) {
            setFullForm(prevForm => ({
                ...prevForm,
                birthplace: {
                    ...prevForm?.birthplace,
                    country: "FR"
                }
            }));
        }
    }, []);

    // Ecouter les changements de selectedBirthplace depuis le contexte
    useEffect(() => {
        if (selectedBirthplace?.city_zip) {
            setFullForm(prevForm => {
                const currentZip = prevForm?.birthplace?.zipcode;
                const currentCity = prevForm?.birthplace?.city;
                const newZip = selectedBirthplace?.zip;
                const newCity = selectedBirthplace?.name;

                // Si les valeurs sont identiques, ne rien faire
                if (currentZip === newZip && currentCity === newCity) {
                    return prevForm;
                }

                const newValues = {
                    ...prevForm,
                    birthplace: {
                        ...prevForm?.birthplace,
                        zipcode: newZip,
                        city: newCity
                    }
                };

                if (pathname?.includes("nouveau")) {
                    setNewForm(newValues);
                }

                return newValues;
            });
        }
    }, [selectedBirthplace?.city_zip, pathname]);

    return (
        <fieldset className="new-birth">
            <div className="form-input">
                <label className={dateRequired ? "required" : ""} htmlFor="birthDate">Date de naissance</label>
                <DateInput
                    placeholder="Date de naissance"
                    required={dateRequired}
                    max="9999-12-31"
                    name="birthDate"
                    value={fullForm?.birthDate || ""}
                    onChange={onChange} />
            </div>
            {(!fullForm?.birthplace?.country || fullForm?.birthplace?.country === "FR") &&
                <CityNameZipSuggest city={fullForm?.birthplace?.city || ""} zipcode={fullForm?.birthplace?.zipcode || ""} zipField="birthZipcode" cityField="birthCity" onChange={onChangeBirthPlaceData} type="birth" />
            }
            {(fullForm?.birthplace?.country && fullForm?.birthplace?.country !== "FR") &&
                <>
                    <div className="form-input">
                        <label htmlFor="birthZipcode">Code postal </label>
                        <input
                            name="birthZipcode"
                            value={fullForm?.birthplace?.zipcode || ""}
                            onChange={onChangeBirthPlaceData}
                            type="text"
                            placeholder="Code postal"
                        />
                    </div>
                    <div className="form-input">
                        <label htmlFor="birthCity">Ville </label>
                        <input
                            name="birthCity"
                            value={fullForm?.birthplace?.city || ""}
                            onChange={onChangeBirthPlaceData}
                            type="text"
                            placeholder="Ville"
                        />
                    </div>
                </>
            }
            <div className="form-input">
                <label className="required" htmlFor="birthCountry">Pays</label>
                <select
                    required={true}
                    name="birthCountry"
                    value={fullForm?.birthplace?.country || "FR"}
                    onChange={onChangeBirthPlaceData}>
                    {
                        countryList.map((country, index) => (
                            <option key={index} name="country"
                                value={country?.code}>{country?.name}</option>
                        ))
                    }
                </select>
            </div>
        </fieldset>
    );
}